
<c11n-modal-dialog
  #messagePreview
  [variant]="'basic'"
  [headingText]="'Preview message text'"
  (closeEvent)="onClosePreviewMessage()"
>
  <div c11n-modal-dialog-body>
    <!-- Body text at top -->
    <div class="mb-3">
      <strong class="mb-1 c11n-text-md-bold">Header</strong>
      <p class="mb-0 c11n-text-md">{{ header }}</p>
    </div>
    <div class="mb-3">
      <strong class="mb-1 c11n-text-md-bold">Text</strong>
      <div *ngFor="let line of messageTextLines; let i = index" class="mb-0" style="white-space: pre-wrap; word-break: break-word">
        <span class="c11n-text-md">{{ i + 1 }} </span><span class="c11n-text-md">{{ line }}</span>
      </div>
    </div>
    <!-- Buttons below -->
    <div class="d-flex flex-md-row gap-2 justify-content-start">
      <c11n-button
        [labelText]="'Close'"
        [variant]="'primary'"
        (clickEvent)="onClosePreviewMessage()"
      ></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
